import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import LogoLink from 'components/logoLink'
import UserProfileSection from './searchbar/UserProfileSection'
import { InView } from 'react-intersection-observer'

const StickyNavbar = ({
  fixed = false,
  children,
}) => {
  const [visible, setVisible] = useState(!fixed)

  const handleScroll = () => {
    setVisible(window.scrollY > 0)
  }

  useEffect(() => {
    if (!fixed || typeof window === 'undefined') {return}
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <InView>
      {({ inView, ref }) => {
        const isFixed = fixed || (!inView && typeof window !== 'undefined' && window.scrollY > 0 && !(screen.width < 1024))

        const relativeClasses = 'w-full shadow-search search-corners bg-white'
        const fixedClasses = 'fixed top-0 left-0 right-0 lg:shadow-public-searchbar bg-white justify-evenly z-30 lg:h-80 bg-white'

        return (
          <div ref={ref} className={`z-20 justify-center flex w-full transition-opacity ${visible ? 'opacity-100 block' : 'opacity-0 hidden'}`}>
            <div className={`w-full ${isFixed && fixedClasses} flex items-center lg:px-40 gap-20`}>
              {isFixed
                ? <LogoLink className="h-55 w-full max-w-[101px] hidden lg:block" />
                : null
              }

              <div className={`${!isFixed && relativeClasses} relative lg:h-80 w-full flex flex-col lg:flex-row items-center mx-auto max-w-[866px]`}>
                {children}
              </div>

              {isFixed
                ? <UserProfileSection />
                : null
              }
            </div>
          </div>
        )
      }}
    </InView>
  )
}

StickyNavbar.propTypes = {
  fixed: PropTypes.bool,
  children: PropTypes.node,
}

export default StickyNavbar
